import Cookies from 'js-cookie'
var userToken = 'user_token';

// 交互token
export function getUserAccessToken() {
  return Cookies.get(userToken)
}
export function setUserAccessToken(token, time) {
  let domainUrl = ''
  if(process.env.VUE_APP_ENV === 'development') {
    domainUrl = '.bjjqe.net'
  }else if(process.env.VUE_APP_ENV === 'production') {
    domainUrl = '.wenjingketang.com'
  }else{}
  Cookies.set(userToken, token, { expires: time, domain: domainUrl })
}
export function removeUserAccessToken() {
  let domainUrl = ''
  if(process.env.VUE_APP_ENV === 'development') {
    domainUrl = '.bjjqe.net'
  }else if(process.env.VUE_APP_ENV === 'production') {
    domainUrl = '.wenjingketang.com'
  }else{}
  Cookies.set(userToken, '', { domain: domainUrl, expires: -1 });
  return Cookies.remove(userToken)
}

// 登录失效清除token并调取登录
export function removeToken() {
  if (process.env.VUE_APP_ENV === 'localhost') {
    removeUserAccessToken()
    location.href = '/login';
  } else if (process.env.VUE_APP_ENV === 'development'){
    // removeUserAccessToken()
    location.href = 'https://wjjy.bjjqe.net/newSchoolv1';
  } else if (process.env.VUE_APP_ENV === 'production') {
    // removeUserAccessToken()
    location.href = 'https://www.wenjingketang.com/newSchool';
  } else {}
}
